import { useContext, useEffect, useState } from 'react';

import { ConfigContext } from 'Context/config';

import { fetchLandingPage } from 'Utilities/wordpressPages';

type FetchConfigStateDataProps = {
  wordpressPathname: string | undefined;
}

export const useFetchConfigStateData = ({ wordpressPathname }: FetchConfigStateDataProps) => {
  const {
    configActions: { update },
    configState: { experimentDecisions, landingPageData },
  } = useContext(ConfigContext);

  const landingPageDataContent = landingPageData?.content;

  const [acf, setAcf] = useState({
    landingPageData: landingPageDataContent,
    slug: wordpressPathname,
  });

  const [apiError, setApiError] = useState(null);

  useEffect(() => {
    if (!Object.keys(acf?.landingPageData ?? {}).length || acf?.slug !== wordpressPathname) {
      fetchLandingPage(`${wordpressPathname}&parent=0`).then((data) => {
        const { content } = data || {};

        setAcf({
          landingPageData: content,
          slug: wordpressPathname,
        });
        setApiError(null);
      }).catch((err: any) => {
        setApiError(err);
        window?.Sentry?.captureException(new Error(`[Checker] landing page ${wordpressPathname}`));
      });
    }

    return () => update({ landingPageData: undefined });
  }, [acf, update, wordpressPathname]);

  return {
    acf: acf?.landingPageData,
    apiError,
    experimentDecisions,
  };
};
